import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=25dd4519&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dd4519",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25dd4519')) {
      api.createRecord('25dd4519', component.options)
    } else {
      api.reload('25dd4519', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=25dd4519&scoped=true&", function () {
      api.rerender('25dd4519', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dw0iCB8iJy7y/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports